export function useCopyToClipboard() {
    const copy = async (text: string): Promise<void> => {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((resolve, reject) => {
                document.execCommand("copy") ? resolve() : reject(new Error("Copy failed"));
                textArea.remove();
            });
        }
    };

    return { copy };
}

export default useCopyToClipboard;
